import { Type } from 'typebox';
import { Person, RoleCodec } from './person.js';
export const GuardianStatus = Type.String({ minLength: 1 });
export const Guardian = Type.Evaluate(Type.Intersect([
    Person,
    Type.Object({
        role: Type.Optional(RoleCodec),
        person: Type.String({ minLength: 1 }),
        actualPersonKey: Type.Optional(Type.String({ minLength: 1 })),
        classification: Type.Optional(Type.String({ minLength: 1 })),
        detailType: Type.Optional(Type.String({ minLength: 1 })),
        relationshipName: Type.Optional(Type.String({ minLength: 1 })),
        status: GuardianStatus,
        familyKey: Type.Optional(Type.String({ minLength: 1 })),
        type: Type.Optional(Type.String({ minLength: 1 })),
        shortNote: Type.Optional(Type.String({ minLength: 1 })),
        detailedNote: Type.Optional(Type.String({ minLength: 1 })),
        restrictAccessToPeerGuardianContacts: Type.Optional(Type.Boolean())
    })
]));
